const FeedBack = {
  feedBackUrl: "/assessment/",
};

export default FeedBack;
